<template lang="pug">
  icon-button(
    class="button--scroll-to-top"
    icon="chevron-up"
    @click="scrollToTop"
    aria-label="Scroll To Top"
  )
</template>

<script>
  import IconButton from 'scripts/components/buttons/IconButton.vue'
  export default {
    name: 'ScrollToTop',
    components: {
      IconButton,
    },
    props: {},
    computed: {},
    methods: {
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .button--scroll-to-top {
    background-color: var(--color-grey-100);
    border-width: 0;
    color: var(--color-navy-500);
    position: fixed;
    bottom: 70px;
    right: 20px;
  }
</style>